import React from "react";
import "../../styles/description/About.css";
import Aos from "aos";
import 'aos/dist/aos.css'
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';

export default function About(props) {
  const { t } = useTranslation();
  useEffect(()=> {
    Aos.init();
  },[])
  return (
    <div className="About--container" ref={props.aboutRef}>
      <div className="About-image" data-aos="fade-right">
      <div className="image-container"></div>
      </div>
      <div className="About-content" data-aos="fade-right">
        <h1 >
          {t("About.first")} <span className="SpanHighlightBlue">{t("About.second")}</span> {t("About.third")}
        </h1>
        <p> {t("About.paragraph_1")} <br /><br /> {t("About.paragraph_2")} <br />{" "}<br /> {t("About.paragraph_3")}
        </p>
      </div>
    </div>
  );
}
